import { createContext, useContext } from "react";

type BreadcrumbLeadingSlotContextType = {
  slot: HTMLElement | null;
};

export const BreadcrumbLeadingSlotContext =
  createContext<BreadcrumbLeadingSlotContextType>({
    slot: null,
  });

export const useBreadcrumbLeadingSlot = (): BreadcrumbLeadingSlotContextType =>
  useContext(BreadcrumbLeadingSlotContext);
